import React from 'react';
import {
  Typography,
  Box,
  Container,
  IconButton,
  styled,
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const StyledFooter = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: theme.spacing(6, 0),
  textAlign: 'center',
}));

const Footer = () => {
  const socialLinks = {
    email: 'mailto:CloudXviiDevelopment@outlook.com',
    instagram: 'https://www.instagram.com/cloudxvii_/',
  };

  return (
    <StyledFooter>
      <Container maxWidth="md">
        {/* Social Icons */}
        <Box sx={{ mb: 2 }}>
          <IconButton
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            sx={{ 
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.2)', // Scale up on hover
              },
            }}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            href={socialLinks.email}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
            sx={{ 
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.2)', // Scale up on hover
              },
            }}
          >
            <EmailIcon />
          </IconButton>
        </Box>

        {/* Footer Text */}
        <Typography variant="body2">
          © {new Date().getFullYear()} Cloud XVII | Websites That Look Great & Perform Flawlessly
        </Typography>
      </Container>
    </StyledFooter>
  );
};

export default Footer;